import * as types from '../actions/actionTypes';

const initialState = {
  departments: [],
  teams: [],
  managers: [],
  employeeTypes: [],
  employmentStatuses: [],
  accessLevels: [],
  loading: false,
  error: null,
};

const referenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_REFERENCE_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_REFERENCE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        departments: action.payload.departments,
        teams: action.payload.teams,
        managers: action.payload.managers,
        employeeTypes: action.payload.employeeTypes,
        employmentStatuses: action.payload.employmentStatuses,
        accessLevels: action.payload.accessLevels,
        error: null,
      };
    case types.FETCH_REFERENCE_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_DEPARTMENTS_SUCCESS:
      return { ...state, departments: action.payload };
    case types.FETCH_TEAMS_SUCCESS:
      return { ...state, teams: action.payload };
    case types.FETCH_MANAGERS_SUCCESS:
      return { ...state, managers: action.payload };

    default:
      return state;
  }
};

export default referenceReducer;